import type { ReactNode } from "react";
import { PageShell } from "../components/PageShell";
import { PromoSlot } from "../components/PromoSlot";
import { fa } from "../i18n/fa";
import { useSession } from "../store/context";

/**
 * Store (فروشگاه) — a real drawer destination. There is no catalogue backend yet,
 * so it presents a tidy, themed EMPTY STATE rather than a dead button: a gold-
 * tinted bag glyph over the «فروشگاه فعلاً خالی است» headline and a muted hint.
 */
export function Store(): ReactNode {
  // ITEM 13 — back goes where the user CAME FROM, like Settings and History. Falling
  // through to PageShell's hardcoded lobby is right only while the drawer is the sole
  // way in; the moment anything else opens this screen it is silently wrong.
  const setView = useSession((st) => st.setView);
  const pageReturn = useSession((st) => st.pageReturn);
  return (
    <PageShell title={fa.store.title} icon="store" onBack={() => setView(pageReturn)}>
      <div className="mt-lg flex flex-col items-center justify-center gap-md rounded-xl border border-dashed border-gold-deep/30 bg-surface-container/40 px-lg py-16 text-center">
        <span
          aria-hidden="true"
          className="flex h-20 w-20 items-center justify-center rounded-full bg-gold-deep/10 text-5xl"
        >
          🛍️
        </span>
        <h2 className="m-0 font-headline-sm text-headline-sm text-gold-deep">{fa.store.empty}</h2>
        <p className="m-0 max-w-xs font-body-md text-body-md text-on-surface-variant">
          {fa.store.hint}
        </p>
      </div>
      {/* Empty-state promo slot — renders nothing today (no campaign / flag off). */}
      <PromoSlot slot="EMPTY_STATE" className="mt-md" />
    </PageShell>
  );
}
